import BossModel from "@/models/BossModel";
import Row from "@/models/PlatinumPage/Version/Element/Row/Row";
import Column from "@/models/PlatinumPage/Version/Element/Row/Column/Column";
import Widget from "@/models/PlatinumWidget/PlatinumWidget";

export default class Element extends BossModel {

    /**
     *
     * @type {string}
     */
    static apiUrl = 'platinum-page/version/element';

    /**
     *
     * @type {string}
     */
    static entity = 'platinumPageVersionElements';

    static fields() {
        return {
            id: this.number(null).nullable(),
            rank: this.number(null).nullable(),
            platinum_page_version_container_id: this.number(null).nullable(),
            platinum_page_version_element_row_column_id: this.number(null).nullable(),
            platinum_page_version_element_row_id: this.number(null).nullable(),
            created_at: this.attr(null),
            updated_at: this.attr(null),
            width_percentage: this.number(null).nullable(),
            platinum_widget_id: this.number(null).nullable(),
            column: this.belongsTo(Column, 'platinum_page_version_element_row_column_id'),
            row: this.belongsTo(Row, 'platinum_page_version_element_row_id'),
            widget: this.belongsTo(Widget, 'platinum_widget_id'),
        }
    }

    /**
     *
     * @returns {Promise<AxiosResponse<T>>}
     * @constructor
     */
    Save() {
        return this.constructor.api().create(this).then((element) => {
            if (element.Widget()) {
                element.Widget().IncreaseElementsCount();
            }
            return element;
        });
    }

    /**
     *
     * @returns {boolean|*}
     * @constructor
     */
    Row() {
        return this.getRelated('row');
    }

    /**
     *
     * @returns {boolean|*}
     * @constructor
     */
    Column() {
        return this.getRelated('column');
    }

    /**
     *
     * @returns {boolean|*}
     * @constructor
     */
    Widget() {
        return this.getRelated('widget');
    }
}
